export const Role = {
    Admin: 2,
    User: 1,
    Assist: 3,
    IlAssist: 4,
    admIl: 5
}
